import { render, staticRenderFns } from "./input-confirm.vue?vue&type=template&id=0fa21e11&scoped=true&"
import script from "./input-confirm.vue?vue&type=script&lang=js&"
export * from "./input-confirm.vue?vue&type=script&lang=js&"
import style0 from "./input-confirm.vue?vue&type=style&index=0&id=0fa21e11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa21e11",
  null
  
)

export default component.exports